@if (controlModel) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <thirdparty-linkable
            #linkableThirdParty
            typename="third party"
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [orderByValueProperty]="true"
            [disabled]="true"
        >
        </thirdparty-linkable>
    }
}
